import { render, staticRenderFns } from "./managerCerts.vue?vue&type=template&id=366b482e&scoped=true&"
import script from "./managerCerts.vue?vue&type=script&lang=js&"
export * from "./managerCerts.vue?vue&type=script&lang=js&"
import style0 from "./managerCerts.vue?vue&type=style&index=0&id=366b482e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366b482e",
  null
  
)

export default component.exports